angular
  .module('estoffice.legacy')
  .controller('BasicSidebarCtrl', basicSidebarCtrl);

function basicSidebarCtrl($scope, $rootScope, request, api, debounce) {
  $scope.markedOffice = false;
  $scope.activateOffices = function (event) {
    event.preventDefault();
    $scope.markedOffice = !$scope.markedOffice;
  };

  $scope.changeBuildingPhase = function () {
    const url = api.basic.buildingPhase.replace(
      '{{sectionId}}',
      $rootScope.sectionId,
    );

    if ($scope.buildingPhase != '...') {
      const data = {
        construction_phase: $scope.buildingPhase,
        token: $rootScope.token,
      };
      request.post(url, data);
    }
  };

  function saveBasic(data) {
    const url = api.basic.buildingPhase.replace(
      '{{sectionId}}',
      $rootScope.sectionId,
    );
    request.post(url, data);
  }

  $scope.changeBindToSingleFloor = function () {
    if (!$scope.bindToSingleFloor) {
      $scope.basicFloorOverride = null;
      saveBasic({ floor_override: '', token: $rootScope.token });
    }
  };

  $scope.changeFloorOverride = function () {
    if ($scope.bindToSingleFloor) {
      debounce(function () {
        saveBasic({
          floor_override: $scope.basicFloorOverride,
          token: $rootScope.token,
        });
      }, 1000);
    }
  };
}
